//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Modal, Badge, Button, ButtonStyle } from '@cmp/common';
//------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { currencyFormatter, referralFormatter } from '@helpers/formatter';
import { ReferralStatus } from '@helpers/constants/referral';
import { StoreConfigContext } from '@helpers/storeConfigContext';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class CheckoutDetails extends React.Component {
  valueRow(title, value) {
    const { t } = this.props;
    return (
      <div
        className={classNames(styles.Row, {
          [styles.Subtotal]: title === t('dashboard_Subtotal'),
        })}
      >
        <span className={styles.Title}>{title}</span>
        <span className={styles.Value}>{value}</span>
      </div>
    );
  }

  render() {
    const { referral, action, onClick, loading, disabled, t } = this.props;
    const {
      storeConfig: { currencySymbol, language },
    } = this.context;

    const finalPrice = referralFormatter.finalPrice(referral);
    const componentClasses = classNames(styles.CheckoutDetails);

    return (
      <div className={componentClasses}>
        {referralFormatter.status(referral) !==
        ReferralStatus.AdditionalPurchase ? (
          <Button
            style={ButtonStyle.Primary}
            onClick={onClick}
            loading={loading}
            disabled={loading || disabled}
            className={styles.SubmitBtn}
          >
            {action}
          </Button>
        ) : null}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(CheckoutDetails);

CheckoutDetails.contextType = StoreConfigContext;
